import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { useWhatsappAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/WhatsappAccountProvider/useWhatsappAccount";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { ChannelTile } from "../ChannelTile";
import { ReactComponent as WhatsappIcon } from "./assets/whatsapp.svg";

export const WhatsappTile: React.FC<{
  isSelected: boolean;
  onSelect: () => void;
}> = (props) => {
  const { t } = useTranslations();
  const { isConnected, whatsappAgent, connectWhatsappAccount } =
    useWhatsappAccount();
  const { openManageAccountDrawer } = useManageAccountsDrawer();

  return (
    <ChannelTile
      title={t({
        id: "common.whatsapp",
        defaultMessage: "WhatsApp",
      })}
      isConnected={isConnected}
      onClick={() =>
        isConnected
          ? openManageAccountDrawer({ name: "whatsappAccount" })
          : connectWhatsappAccount()
      }
      description={
        isConnected
          ? `ID: ${whatsappAgent?.waba_id}, ${whatsappAgent?.phone_number.display_phone_number}`
          : t({
              id: "cx-ai-agents-page.whatsapp-connect-description",
              defaultMessage: "Reply faster with WhatsApp chat",
            })
      }
      icon={<WhatsappIcon />}
      pillText={
        isConnected
          ? t({
              id: "common.connected",
              defaultMessage: "Connected",
            })
          : undefined
      }
      {...props}
    />
  );
};
